import { render, staticRenderFns } from "./FaturaDetalhes.vue?vue&type=template&id=76701983"
import script from "./FaturaDetalhes.vue?vue&type=script&lang=js"
export * from "./FaturaDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports